import type { ReactNode } from 'react';
import './SearchFilterBar.css';

export type SearchFilterBarProps = {
  search?: ReactNode;
  filters?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export const SearchFilterBar = ({
  search,
  filters,
  meta,
  actions,
  className,
}: SearchFilterBarProps) => {
  return (
    <div className={['search-filter-bar', className].filter(Boolean).join(' ')}>
      {(search || filters) && (
        <div className="search-filter-bar__controls">
          {search && <div className="search-filter-bar__search">{search}</div>}
          {filters && <div className="search-filter-bar__filters">{filters}</div>}
        </div>
      )}
      {(meta || actions) && (
        <div className="search-filter-bar__meta">
          {meta && <div className="search-filter-bar__summary">{meta}</div>}
          {actions && <div className="search-filter-bar__actions">{actions}</div>}
        </div>
      )}
    </div>
  );
};

export default SearchFilterBar;
